import React from 'react';

export default function InfoWindowChrome() {
  return (
    <div className="info-window-controls" aria-hidden="true">
      <span className="info-window-btn close" />
      <span className="info-window-btn minimize" />
      <span className="info-window-btn zoom" />
    </div>
  );
}
